import { Theme } from "@material-ui/core";
// import CheckCircle from "@material-ui/icons/CheckCircle";
// import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
// import RemoveCircle from "@material-ui/icons/RemoveCircle";

export const createThemeComponents = (theme: Theme) => ({
  MuiPagination: {
    styleOverrides: {
      ul: {
        justifyContent: "center",
      },
    },
  },

  MuiAccordion: {
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(3),
        "&.Mui-expanded:last-of-type": {
          marginBottom: theme.spacing(3),
        },
        "&:before": {
          content: "none",
        },
      },
    },
  },
  MuiCssBaseline: {
    "@global": {
      overflowY: "auto",
      // scrollBarWidth: "thin",
      width: "4px",
      height: "4px",
      "*::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
    },
    styleOverrides: {
      "#root": {
        height: "100vh",
        width: "100%",
        overflowY: "auto",
      },
      "#main": {
        maxHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        // marginBottom: "2vh",
      },
      "#app-bar": {
        // maxHeight: "10vh",
        marginBottom: "20px",
        filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.08))",
        background: "#fff",
        zIndex: 1,
        boxShadow: "0px 0px 0px 2px #00000014",
        // backgroundColor: "#fff",
      },
      ".blog-links": {
        color: "#444BD3",
        transition: "all 100ms ease-in-out",
        "&:hover": {
          transform: "translateY(-1px)",
        },
      },
      ".new-card": {
        cursor: "pointer",
        transition: "all 100ms ease-in-out",
        "&:hover": {
          transform: "translateY(-1px)",
        },
        ".blog-links": {
          color: "#444BD3",
        },
      },

      ".link-card": {
        padding: "10px",
        // height: "100px",
        minWidth: "120px",
        marginBottom: "8px",
        transition: "all 100ms ease-in-out",
        "&:hover": {
          background: "#fff",
          boxShadow:
            "0 3.2px 7.2px 0 rgba(0, 0, 0, .132), 0 .6px 1.8px 0 rgba(0, 0, 0, .108)",
          borderRadius: "5px",
          transform: "translateY(-1px)",
        },
      },
      ".history-text": {
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.00938em",
        color: "#222",
        fontSize: "14px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      ".anchorlink": {
        textDecoration: "none",
        cursor:"pointer",
        color:"#0568fd",
      },
      ".chathistory-text": {
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0.00938em",
        color: "#222",
        fontSize: "14px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "150px",
        height: "30px",
      },
      ".custom-dot": {
        width: "40px !important",
        height: "5px !important",
        borderRadius: "30px !important", // Adjust border radius to make it look like a line
        backgroundColor: "#c3d3eb !important", // Change color of the dot
        "@media (min-width: 600px)": {
          width: "100px !important",
        },
        "@media (min-width: 768px) and (max-width:1023px)": {
          width: "80px !important",
        },
      },
      ".custom-dot-active": {
        backgroundColor: "#0053CC !important",
      },
      ".treeListItem": {
        li: {
          ".Mui-selected": {
            background: "#2458940a",
            padding: "10px",
          },
        },
      },
      ".price-planning": {
        ".MuiCardHeader-avatar": {
          marginRight: 0,
        },
      },
      ".mfc-detials-model-table": {
        thead: {
          tr: {
            th: {
              fontWeight: "700",
              fontFamily: "segoeuib",
              color: "#455A64",
              cursor: "pointer",
            },
          },
        },
      },
      ".news-content": {
        p: {
          margin: "8px 0 0",
        },
      },
      ".chat-container": {
        background: "#fff",
        padding: "10px",
        marginBottom: "10px",
        boxShadow: "0px 0px 2px 2px #00000014",
        borderRadius: "5px",
        maxHeight: "520px",
        overflowY: "auto",
        ".chat-history-container": {
          ".svg-styles": {
            cursor: "pointer",
          },
        },
        ".chat-history-view": {
          display: "flex",
          flexDirection: "column",
          ".chat-history-view-item": {
            display: "flex",
            ".chat-history-view-item-icon": {
              flexGrow: "1",
              maxWidth: "10%",
            },
            ".chat-history-view-item-content": {
              flexGrow: 2,
              maxWidth: "90%",
              background: "#F5F5F5",
              borderRadius: "10px",
              padding: "16px",
            },
          },
          ".svg-styles": {
            // width: "100%",
            height: "24px",
            cursor: "pointer",
          },
        },
        ".chat-history-list": {
          borderRadius: "35px",
          border: "1px solid #245894",
          padding: "14px 16px 14px 16px",
          cursor: "pointer",
          tranistion: "0.3s ease",
          "&:hover": {
            background: "#F4F9FF",
          },
          ".chat-prompt": {
            display: "flex",
            ".svg-styles": {
              width: "100%",
              height: "24px",
              flexGrow: "1",
              maxWidth: "10%",
            },
            p: {
              flexGrow: 2,
              maxWidth: "90%",
            },
          },
        },
      },

      ".reference-link": {
        boxShadow: "0px 0px 0.8999999761581421px 1px #00000014",
        padding: "20px",
        textAlign: "center",
        minHeight: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        color: "#222",
        cursor: "pointer",
        "&:hover": {
          background: "#245894",
          color: "#fff",
          transition: "0.3s ease",
          ".reference-icon": {
            color: "#fff",
          },
        },
        ".reference-icon": {
          margin: "0 auto",
          backgroundColor: "transparent",
          color: "#245894",
        },
      },
      "#page-main": {
        padding: "0 12px",
        // minHeight: "100vh",
        // marginBottom: "12px",
        // maxHeight: "90vh",
        background: "#ECEFF1",

        ".priceGpt": {
          border: "1px solid black",
          table: {
            borderSpacing: "0px",
            tbody: {
              tr: {
                borderSpacing: "0px",
                th: {
                  textAlign: "left",
                  border: "1px solid black",
                  borderCollapse: "collapse",
                  borderSpacing: "0px",
                },
                td: {
                  border: "1px solid black",
                  borderCollapse: "collapse",
                  borderSpacing: "0px",
                  a: {
                    color: "rgba(56, 138, 232, 0.87)",
                  },
                },
              },
            },
          },
        },
        ".mainTable": {
          width: "auto",
          minWidth: "100%",
          borderSpacing: "0px",
          thead: {
            tr: {
              td: {
                fontWeight: "700",
                fontFamily: "segoeuib",
                color: "#455A64",
                cursor: "pointer",
                borderBottom: "1px solid rgb(207, 216, 220)",
              },
            },
          },
          tbody: {
            tr: {
              "&:nth-of-type(odd)": {
                // backgroundColor:"red"
              },
              td: {
                padding: "10px 0",
                borderBottom: "1px solid rgb(207, 216, 220)",
              },
            },
          },
          ".firstTable": {
            tbody: {
              tr: {
                td: {
                  borderBottom: "1px solid rgb(207, 216, 220)",
                  "last-chiild": {
                    borderBottom: "none",
                  },
                },
              },
            },
            ".secondTable": {
              tbody: {
                tr: {
                  td: {
                    borderBottom: "1px solid rgb(207, 216, 220)",
                  },
                },
              },
              ".thirdTable": {
                tbody: {
                  tr: {
                    td: {
                      borderBottom: "none",
                    },
                  },
                },
              },
            },
          },
        },
        ".level1onetable": {
          thead: {
            tr: {
              th: {
                fontWeight: "700",
                fontFamily: "segoeuib",
                color: "#455A64",
                cursor: "pointer",
                textAlign: "right",
                // lineHeight: 1,
                // padding: "10px",
              },
            },
          },
          tbody: {
            tr: {
              td: {
                padding: "10px",
                fontSize: "13px",
                // width:"250px"
              },
            },
          },
        },
        ".level2onetable": {
          tbody: {
            tr: {
              td: {
                padding: "10px",
                // width:"250px"
              },
            },
          },
        },
      },
      body: {
        // maxWidth: "1920px",
        fontSize: "14px",
        backgroundColor: "none",
        ".css-19knb6j-MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
          borderRadius: "4px",
        },
        ".svg-styles": {
          // width: "100%",
          height: "24px",
          cursor: "pointer",
          marginRight:"25px"
        },
        ".breadCrumtilte":{
          color:"#222",
          lineHeight:"18.62px",
          paddingRight:"10px"
        },
        ".hidden": {
          display: "none",
        },
        ".dateRanger": {
          // width: "150px",
          // borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
          // cursor:"pointer",
          position: "absolute",
          left: "0",
          // "div[class*='materialui-daterange-picker-MuiPaper-root- materialui-daterange-picker-MuiPaper-elevation5-']": {

          // }
        },
        ".range-picker": {
          position: "absolute",
          right: "0",
        },
        ".custom-range-picker": {
          position: "absolute",
          right: "none",
        },
        ".criteria-pattern": {
          borderRadius: "4px",
          border: "1px dashed #555",
          background: "#F4F4F4",
          margin: "10px 0",
          padding: "0 20px",
        },
        ".label": {
          fontSize: "14px",
          lineHeight: "22px",
          color: "#222",
          fontWeight: 700,
          fontFamily: "segoeuib",
          padding: "0 10px",
        },
        ".label-text": {
          fontSize: "14px",
          lineHeight: "22px",
          color: "#222",
          fontWeight: 400,
          fontFamily: "segoeui",
          padding: "0 10px",
        },
        ".healthDateRanger": {
          position: "absolute",
          left: "0",
          top: "0",
        },
        "*": {
          "scrollbarWidth": "inherit",
        },
        "*::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
          scrollBehavior: "smooth",
        },
        // scrollbarColor: "#6b6b6b #2b2b2b",
        "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
          backgroundColor: "#fff",
        },
        "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
          borderRadius: 0,
          backgroundColor: "#6b6b6b69",
          minHeight: 15,
          border: "0px solid #2b2b2b",
          scrollBehavior: "smooth",
          width: "4px",
          height: "4px",
        },
        "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
          {
            backgroundColor: "#959595",
          },
        "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
          {
            backgroundColor: "#959595",
          },
        "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
          {
            backgroundColor: "#959595",
          },
        "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
          backgroundColor: "#2b2b2b",
        },
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: theme.spacing(1, 3, 3),
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: 0,
        ".Mui-expanded": {
          margin: 0,
          minHeight: 0,
        },
        ".MuiCollapse-wrapper": {
          paddingLeft: 0,
          minHeight: 0,
        },
      },
      content: {
        margin: 0,
        minHeight: 0,
        ".Mui-expanded": {
          margin: 0,
          minHeight: 0,
        },
        ".MuiCollapse-wrapper": {
          margin: 0,
          minHeight: 0,
        },
      },
    },
  },
  // MuiCollapse:{
  //   styleOverrides:{
  //     root:{
  //       ".MuiCollapse-wrapper":{
  //         paddingLeft:0,
  //       }
  //     }
  //   }
  // },

  MuiAppBar: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        "&.MuiAppBar-colorDefault": {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        },
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        color: "inherit",
        backgroundColor: theme.palette.background.default,
        width: 30,
        height: 30,
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        padding: "16px 24px",
        textTransform: "none" as any,
      },
      label: {
        fontWeight: theme.typography.fontWeightMedium,
      },
      text: {
        padding: "16px 16px",
      },
    },
  },
  // MuiPickersDay: {
  //   styleOverrides: {
  //     root: {
  //       fontSize: 18,
  //       width: 60,
  //       height: 60,
  //       margin: 0,
  //     },
  //   },
  // },
  // MuiDateCalendar: {
  //   styleOverrides: {
  //     root: {
  //       width: "100%",
  //       maxHeight: "unset",
  //       alignItems: "center",
  //     },
  //   },
  // },
  // MuiPickersCalendarHeader: {
  //   styleOverrides: {
  //     root: {
  //       padding: "0",
  //       width: "440px",
  //     },
  //   },
  // },
  // MuiDayCalendar: {
  //   styleOverrides: {
  //     weekDayLabel: {
  //       fontSize: 25,
  //       width: 60,
  //       height: 60,
  //       backgroundColor: "#ddd",
  //     },
  //     slideTransition: {
  //       minHeight: 375,
  //     },
  //   },
  // },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true, // No more ripple, on the whole application
    },
    styleOverrides: {
      root: {},
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "4px",
      },
    },
  },
  MuiCardActions: {
    styleOverrides: {
      root: {
        justifyContent: "flex-end",
        padding: "0 24px 24px 24px",
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: theme.spacing(3),
      },
    },
  },
  MuiCardHeader: {
    styleOverrides: {
      root: {
        padding: "24px 24px 0 24px",
      },
    },
  },
  MuiCheckbox: {
    defaultProps: {
      // checkedIcon: <CheckCircle />,
      // indeterminateIcon: <RemoveCircle />,
      // icon: <RadioButtonUnchecked />,
    },
  },
  MuiChip: {
    styleOverrides: {
      label: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: 24,
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: 24,
        "& .MuiTypography-root": {
          fontSize: "1.25rem",
        },
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        border: "none; !important",
      },
    },
  },
  MuiFab: {
    styleOverrides: {
      root: {
        boxShadow: "none",
        lineHeight: "inherit",
        textTransform: "none" as any,
        "&.MuiFab-secondary": {
          color: theme.palette.text.primary,
        },
      },
    },
  },
  MuiFilledInput: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadius,
      },
    },
  },
  MuiInternalClock: {
    styleOverrides: {
      clock: {
        backgroundColor: theme.palette.background.default,
      },
    },
  },
  // MuiInternalDateTimePickerTabs: {
  //   styleOverrides: {
  //     tabs: {
  //       backgroundColor: theme.palette.background.default,
  //       "& MuiTabs-indicator": {
  //         height: 0,
  //         backgroundColor: "",
  //       },
  //     },
  //   },
  // },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        // borderRadius: 16,
        height: 12,
      },
    },
  },
  MuiList: {
    styleOverrides: {
      root: {
        padding: "12px 0",
        // margin: '0 auto',
        TextAlign: "center",
      },
    },
    defaultProps: {
      disablePadding: true,
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        // borderRadius: 16,
        padding: "12px 15px",
        margin: "10px 0",
        "&.Mui-selected": {
          // backgroundColor: theme.palette.background.default,
          backgroundColor: "#ddd",
          color: theme.palette.text.primary,
          borderLeft: "6px solid #388AE8",
        },
      },
    },
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minWidth: "30px",
      },
    },
  },
  MuiListItemText: {
    styleOverrides: {
      primary: {
        fontSize: 14,
        fontFamily: "segoeui",
        fontWeight: 400,
        // fontWeight:700,
      },
    },
  },
  MuiCollapse: {
    styleOverrides: {
      wrapper: {
        paddingLeft: 0,
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 40,
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      list: {
        paddingRight: 8,
        paddingLeft: 8,
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
  },
  MuiInput: {
    styleOverrides: {
      root: {
        fontFamily: "segoeui !important",
        fontSize: "14px",
        fontWeight: 400,
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        input: {
          fontFamily: "segoeui",
          fontSize: "14px",
          fontWeight: 400,
          // padding:"3px 4px 3px 0"
          "&.data-picker-class": {
            padding: "3px 4px 3px 0",
          },
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontFamily: "segoeui",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "1.2em",
      },
    },
  },

  MuiAutocomplete: {
    styleOverrides: {
      root: {
        fontFamily: "segoeui",
        fontSize: "14px",
        fontWeight: 400,
      },
      option: {
        fontFamily: "segoeui",
        fontSize: "14px",
        fontWeight: 400,
      },
      noOptions: {
        fontFamily: "segoeui",
        fontSize: "14px",
        fontWeight: 400,
      },
      paper: {
        borderRadius: "4px",
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontFamily: "segoeui",
        fontSize: "14px",
        fontWeight: 400,
        borderRadius: "0",
        color: "#222",
        "&.input-rule": {
          borderRadius: "3px",
          // border:"1px solid #555",
          input: {
            // height: "1em"
            borderRadius: "3px",
            // border:"1px solid #555"
          },
        },
        input: {
          fontFamily: "segoeui",
          fontSize: "14px",
          fontWeight: 400,
          // height:"1em",
          "&:-webkit-autofill": {
            WebkitBoxShadow: `0 0 0 30px ${theme.palette.background.paper} inset`,
            "&#demo-Scope-select": {
              // height: "1em",
              // padding: "13px 14px"
            },
          },
        },
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        "&.description": {
          borderRadius: "0",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "0",
        },
      },
    },
  },
  // MuiInput: {
  //   styleOverrides: {
  //     root: {
  //       fontFamily: "segoeui",
  //       fontSize: "14px",
  //       fontWeight: 400,
  //     },
  //   },
  // },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: "none",
        borderRadius: "4px",
      },
      MuiPopover: {
        Paper: {
          styleOverrides: {
            MuiMenuPaper: {
              styleOverrides: {
                root: {
                  borderRadius: "4px",
                },
              },
            },
          },
        },
      },
    },
  },
  MuiMenuPaper: {
    styleOverrides: {
      root: {
        borderRadius: "4px",
      },
    },
  },
  MuiRadio: {
    defaultProps: {
      color: "primary" as "primary",
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        borderRadius: 5,
        padding: "10px 16px",
        maxWidth: "initial !important",
        minHeight: "initial !important",
        minWidth: "initial !important",
        textTransform: "none" as any,
        fontFamily: "seguisb",
        fontWeight: "600",
        fontSize: 16,
        "&.Mui-selected": {
          // backgroundColor: "#388AE8",
          // color: "rgba(255, 255, 255, 0.90)",
        },
        "&.MuiTabs-indicator": {
          backgroundColor: "transparent",
        },
      },
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: "auto",
        "&.view-tabs": {
          ".MuiTabs-indicator": {
            backgroundColor: "transparent",
          },
          "&.rules-tabs": {
            marginBottom: "10px",
          },
          "&.business-rules-tabs": {
            "&.MuiTabs-indicator": {
              height: "2.5px",
            },
          },
          ".Mui-selected": {
            backgroundColor: "#388AE8",
            color: "rgba(255, 255, 255, 0.90)",
          },
        },
      },
    },
    // MUiTab: {
    //   MuiButtonBase:{
    //   styleOverrides: {
    //     root: {
    //         ".Mui-selected": {
    //           backgroundColor: "#388AE8",
    //           color: "rgba(255, 255, 255, 0.90)",
    //         },
    //       },
    //     }
    //   },
    // }
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        "&:last-child td": {
          borderBottom: 0,
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: "4px 8px",
        fontWeight: 400,
        fontFamily: "segoeui",
        fontSize: "14px",
        textTransform: "capitalize",
      },
      sizeSmall: {
        padding: "12px 16px",
      },
    },
  },

  MuiTimeline: {
    styleOverrides: {
      root: {
        padding: "0 0 0 16px",
      },
    },
  },
  MuiTimelineOppositeContent: {
    styleOverrides: {
      root: {
        width: "100px",
      },
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        color: theme.palette.text.secondary,
        borderRadius: 0,
        border: "none",
        textTransform: "none" as any,

        "&.Mui-selected": {
          backgroundColor: theme.palette.background.paper,
          // backgroundColor:"#ddd",
          color: theme.palette.text.primary,
          borderRadius: 0,
        },
      },
    },
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.background.default,
        padding: 5,
      },
    },
  },
  buttonIcon: {
    marginRight: "0",
    // marginLeft: "2px",
  },
  MuiPopover: {
    styleOverrides: {
      root: {
        paper: {
          borderRadius: "4px",
        },
      },
    },
  },
  MuiInPutBase: {
    styleOverrides: {
      root: {
        marginTop: "13px",
      },
    },
  },
});
